import { useState } from "react";
import { Menu, X, Phone } from "lucide-react";
import { Logo } from "./Logo";
import { NAV_LINKS, PHONE, PHONE_LINK } from "@/data/content";

const Navbar = () => {
    const [open, setOpen] = useState(false);
    return (
        <header className="fixed top-0 inset-x-0 z-50 bg-[#0A1128]/85 backdrop-blur-md border-b border-white/10">
            <div className="max-w-7xl mx-auto px-5 sm:px-8 h-[72px] flex items-center justify-between gap-4">
                <Logo />
                <nav className="hidden lg:flex items-center gap-7" data-testid="nav-links">
                    {NAV_LINKS.map((l) => (
                        <a
                            key={l.href}
                            href={l.href}
                            data-testid={`nav-link-${l.label.toLowerCase().replace(/\s+/g, "-")}`}
                            className="text-sm text-slate-300 hover:text-sky-400 transition-colors duration-200"
                        >
                            {l.label}
                        </a>
                    ))}
                </nav>
                <div className="hidden lg:flex items-center gap-3">
                    <a
                        href={PHONE_LINK}
                        data-testid="nav-phone-link"
                        className="flex items-center gap-2 text-sm text-slate-300 hover:text-white transition-colors"
                    >
                        <Phone size={15} className="text-sky-400" />
                        <span className="font-mono2 text-xs tracking-wider">{PHONE}</span>
                    </a>
                    <a
                        href="#contact"
                        data-testid="nav-cta-consultation"
                        className="ml-2 px-5 py-2.5 rounded-full bg-blue-600 hover:bg-blue-500 text-white text-sm font-semibold transition-colors duration-200"
                    >
                        Request a Consultation
                    </a>
                </div>
                <button
                    data-testid="nav-mobile-toggle"
                    onClick={() => setOpen(!open)}
                    className="lg:hidden text-white p-2"
                    aria-label="Toggle menu"
                >
                    {open ? <X size={22} /> : <Menu size={22} />}
                </button>
            </div>
            {open && (
                <div className="lg:hidden bg-[#0A1128] border-b border-white/10 px-5 pb-6 pt-2" data-testid="nav-mobile-menu">
                    {NAV_LINKS.map((l) => (
                        <a
                            key={l.href}
                            href={l.href}
                            onClick={() => setOpen(false)}
                            data-testid={`nav-mobile-link-${l.label.toLowerCase().replace(/\s+/g, "-")}`}
                            className="block py-3 text-sm text-slate-200 border-b border-white/5"
                        >
                            {l.label}
                        </a>
                    ))}
                    <a
                        href="#contact"
                        onClick={() => setOpen(false)}
                        data-testid="nav-mobile-cta"
                        className="mt-4 block text-center px-5 py-3 rounded-full bg-blue-600 text-white text-sm font-semibold"
                    >
                        Request a Consultation
                    </a>
                </div>
            )}
        </header>
    );
};

export default Navbar;
